import {
  CleanActivitySheet,
  CleanActivitySheetItem,
  CLEAN_WEEK_LABELS,
  cleanWeekResultLabel,
  normalizeWeekResults,
  parseCleanSheetItems,
} from '../../types/cleanActivity';
import ApprovalStampBox from '../approval/ApprovalStampBox';
import './CleanActivityPanel.css';
import '../product/InspectionFormSheet.css';

interface Props {
  sheet: CleanActivitySheet;
}

function SheetItems({ items }: { items: CleanActivitySheetItem[] }) {
  return (
    <div className="ca-week-table-wrap">
      <table className="ca-week-table">
        <thead>
          <tr>
            <th style={{ width: 40 }}>#</th>
            <th style={{ width: 110 }}>구역</th>
            <th>점검내용</th>
            <th style={{ width: 100 }}>방법</th>
            {CLEAN_WEEK_LABELS.map((label) => (
              <th key={label} style={{ width: 72 }}>
                {label}
              </th>
            ))}
            <th style={{ width: 140 }}>발견사항</th>
            <th style={{ width: 120 }}>비고</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={10} className="ca-empty">
                등록된 점검 항목이 없습니다.
              </td>
            </tr>
          ) : (
            items.map((item, idx) => {
              const weeks = normalizeWeekResults(item);
              return (
                <tr key={item.id}>
                  <td>{idx + 1}</td>
                  <td className="ca-week-table__cell">
                    <div className="ca-week-table__text">{item.area || '-'}</div>
                  </td>
                  <td className="ca-week-table__check">
                    <div className="ca-week-table__text">{item.checkItem || '-'}</div>
                  </td>
                  <td className="ca-week-table__cell">
                    <div className="ca-week-table__text">{item.method || '-'}</div>
                  </td>
                  {weeks.map((weekValue, weekIdx) => (
                    <td key={`${item.id}-w${weekIdx}`} className="ca-week-table__week">
                      <span
                        className={`ca-week-chip is-${(weekValue || 'empty').toLowerCase() || 'empty'}`}
                      >
                        {cleanWeekResultLabel(weekValue)}
                      </span>
                    </td>
                  ))}
                  <td className="ca-week-table__note">
                    <div className="ca-week-table__text">{item.finding || '-'}</div>
                  </td>
                  <td className="ca-week-table__note">
                    <div className="ca-week-table__text">{item.remark || '-'}</div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}

/** 청정활동 점검시트 — 원본 상세와 동일한 읽기 전용 양식 */
function CleanActivitySheetView({ sheet }: Props) {
  const items = parseCleanSheetItems(sheet.itemsJson);
  return (
    <div className="quality-form">
      <div className="ifs-sheet">
        <div className="ifs-sheet__top">
          <div>
            <h4 className="ifs-sheet__title">{sheet.title || '청정활동 점검시트'}</h4>
            <p className="ifs-sheet__subtitle">
              {sheet.checkDate || '-'} · {sheet.areaName || '구역 미입력'}
            </p>
          </div>
          <ApprovalStampBox
            authorName={sheet.authorName}
            reviewerName={sheet.reviewerName}
            approverName={sheet.approverName}
          />
        </div>
        <div className="ca-meta-grid">
          <label>
            문서번호
            <input readOnly value={sheet.sheetNo || '-'} />
          </label>
          <label>
            점검일
            <input readOnly value={sheet.checkDate || '-'} />
          </label>
          <label className="is-span-2">
            점검 구역
            <input readOnly value={sheet.areaName || '-'} />
          </label>
          <label>
            점검자
            <input readOnly value={sheet.checkerName || '-'} />
          </label>
        </div>
      </div>

      <div className="quality-form__section">
        <h3>점검 항목</h3>
        <SheetItems items={items} />
      </div>

      <div className="quality-form__section">
        <div className="quality-form__stack">
          비고
          <textarea rows={3} readOnly value={sheet.remark || ''} />
        </div>
      </div>
    </div>
  );
}

export default CleanActivitySheetView;
